import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Typography } from '@mui/material';
import { breakpoints } from '../../theme/theme';

const TabView = ({ tabsData, isTestCaseAutomationTabVisible = false, onTabChange, parentActiveTab, className, size = 'medium' }) => {
  const filteredTabsData = tabsData.filter(
    (tab) => !( !isTestCaseAutomationTabVisible && tab.name === 'Test Case Automation' )
  );

  const [activeTab, setActiveTab] = useState(parentActiveTab || 0);

  useEffect(() => {
    if (typeof parentActiveTab === "number") {
      setActiveTab(parentActiveTab);
    }
  }, [parentActiveTab]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    // Call the parent's onTabChange if provided
    if (onTabChange) {
      onTabChange(event, newValue);
    }
  };

  // Size configurations
  const getSizeConfig = () => {
    switch (size) {
      case 'small':
        return {
          minHeight: { xl: '38px', md: '32px' },
          height: { xl: '38px', md: '32px' },
          fontSize: { xl: '12px', md: '10px' },
          px: 2,
          borderBottom: '1px solid #e5e7eb'
        };
      case 'large':
        return {
          minHeight: { xl: '60px', md: '48px' },
          height: { xl: '60px', md: '48px' },
          fontSize: { xl: '18px', md: '14px' },
          px: 2,
          borderBottom: '1px solid #e5e7eb'
        };
      default: // medium
        return {
          minHeight: { xl: '52px', md: '38px' },
          height: { xl: '52px', md: '38px' },
          fontSize: { xl: '15px', md: '12px' },
          px: 2,
          borderBottom: '1px solid #e5e7eb'
        };
    }
  };

  const sizeConfig = getSizeConfig();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }} className={className}>
      {/* Tabs Section */}
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{
          borderBottom: sizeConfig.borderBottom,
          flexShrink: 0,
          minHeight: sizeConfig.minHeight,
          height: sizeConfig.height,
        }}
      >
        {filteredTabsData.map((tab, index) => (
          <Tab
            key={index}
            label={
              <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                {tab.icon}
                <Typography 
                  component="p" 
                  sx={{
                    fontSize: sizeConfig.fontSize,
                  }}
                >
                  {tab.name}
                </Typography>
                {/* {tab.name} */}
              </span>
            }
            sx={{ 
              px: sizeConfig.px, 
              minHeight: sizeConfig.minHeight,
              height: sizeConfig.height,
              color: '#64748b',
            }}
          />
        ))}
      </Tabs>

      {/* Tab Content Section - Only this is scrollable */}
      <Box sx={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
        {filteredTabsData[activeTab]?.component}
      </Box>
    </Box>
  );
};

export default TabView;
